import type { FC } from 'react';
import React, { useState } from 'react';
import { match } from 'variant';
import { useAppDeploymentTopologyUpdater } from './useAppDeploymentTopologyUpdater.js';
import { useERCManifestUpdateNotifier } from './useERCManifestUpdateNotifier.js';
import { ScreenState } from './screen-state.js';
import { SiteSelectorScreen } from './SiteSelectorScreen.js';
import { HomeScreen } from './HomeScreen.js';

export const AppDev: FC = () => {
  const [screen, setScreen] = useState<ScreenState>(ScreenState.Home());

  useAppDeploymentTopologyUpdater();
  useERCManifestUpdateNotifier();

  return match(screen, {
    Home: () => <HomeScreen onScreenChange={setScreen} />,
    SiteSelector: () => <SiteSelectorScreen onScreenChange={setScreen} />,
  });
};
